const inputConfig = {
  fullCitation: {
    apa: {
      article: {
        required: ["title", "container-title", "volume", "page", "issued"],
        optional: ["issue", "DOI", "ISSN", "URL"],
      },
      "article-journal": {
        required: ["title", "container-title", "volume", "page", "issued"],
        optional: ["issue", "DOI", "ISSN", "URL"],
      },
      "article-magazine": {
        required: ["title", "container-title", "page", "issued"],
        optional: ["DOI", "URL"],
      },
      "article-newspaper": {
        required: ["title", "container-title", "page", "issued"],
        optional: ["DOI", "URL"],
      },
      book: {
        required: ["title", "publisher", "issued"],
        optional: ["publisher-place", "edition", "ISBN", "URL"],
      },
      broadcast: {
        required: ["title", "container-title", "issued"],
        optional: ["URL"],
      },
      document: {
        required: ["title", "type"],
        optional: ["URL"],
      },
      interview: {
        required: ["title", "interviewee", "interviewer", "issued"],
        optional: ["URL"],
      },
      map: {
        required: ["title"],
        optional: ["issued", "URL"],
      },
      post: {
        required: ["title", "container-title", "issued"],
        optional: ["URL"],
      },
      report: {
        required: ["title", "publisher", "issued"],
        optional: ["publisher-place", "number", "URL"],
      },
      review: {
        required: ["title", "item"],
        optional: ["URL"],
      },
      thesis: {
        required: ["title", "publisher", "issued"],
        optional: ["publisher-place", "advisor", "URL"],
      },
      webpage: {
        required: ["title", "accessed"],
        optional: ["container-title", "publisher", "issued", "URL"],
      },
    },
    mla: {
      article: {
        required: ["title", "container-title", "volume", "page", "issued"],
        optional: ["issue", "DOI"],
      },
      "article-journal": {
        required: ["title", "container-title", "volume", "page", "issued"],
        optional: ["issue", "DOI"],
      },
      "article-magazine": {
        required: ["title", "container-title", "page", "issued"],
        optional: ["DOI"],
      },
      "article-newspaper": {
        required: ["title", "container-title", "page", "issued"],
        optional: ["DOI"],
      },
      book: {
        required: ["title", "publisher", "issued"],
        optional: ["edition", "ISBN", "URL"],
      },
      broadcast: {
        required: ["title", "container-title", "issued"],
        optional: ["URL"],
      },
      document: {
        required: ["title", "type"],
        optional: ["URL"],
      },
      interview: {
        required: ["title", "interviewee", "interviewer", "issued"],
        optional: ["URL"],
      },
      map: {
        required: ["title"],
        optional: ["issued", "URL"],
      },
      post: {
        required: ["title", "container-title", "issued"],
        optional: ["URL"],
      },
      report: {
        required: ["title", "publisher", "issued"],
        optional: ["number", "URL"],
      },
      review: {
        required: ["title", "item"],
        optional: ["URL"],
      },
      thesis: {
        required: ["title", "publisher", "issued"],
        optional: ["advisor", "URL"],
      },
      webpage: {
        required: ["title", "accessed"],
        optional: ["container-title", "publisher", "issued", "URL"],
      },
    },
    chicago: {
      article: {
        required: ["title", "container-title", "volume", "pages", "issued"],
        optional: ["issue", "DOI"],
      },
      "article-journal": {
        required: ["title", "container-title", "volume", "pages", "issued"],
        optional: ["issue", "DOI"],
      },
      "article-magazine": {
        required: ["title", "container-title", "page", "issued"],
        optional: ["DOI"],
      },
      "article-newspaper": {
        required: ["title", "container-title", "page", "issued"],
        optional: ["DOI"],
      },
      book: {
        required: ["title", "place-publisher", "issued"],
        optional: ["edition", "ISBN", "URL"],
      },
      broadcast: {
        required: ["title", "container-title", "issued"],
        optional: ["URL"],
      },
      document: {
        required: ["title", "type"],
        optional: ["URL"],
      },
      interview: {
        required: ["title", "interviewee", "interviewer", "issued"],
        optional: ["URL"],
      },
      map: {
        required: ["title"],
        optional: ["issued", "URL"],
      },
      post: {
        required: ["title", "container-title", "issued"],
        optional: ["URL"],
      },
      report: {
        required: ["title", "place-publisher", "issued"],
        optional: ["number", "URL"],
      },
      review: {
        required: ["title", "item"],
        optional: ["URL"],
      },
      thesis: {
        required: ["title", "place-publisher", "issued"],
        optional: ["advisor", "URL"],
      },
      webpage: {
        required: ["title", "accessed"],
        optional: ["container-title", "place-publisher", "issued", "URL"],
      },
    },
  },
  textCitation: {
    article: {
      required: ["title", "container-title", "issued"],
    },
    "article-journal": {
      required: ["title", "container-title", "issued"],
    },
    "article-magazine": {
      required: ["title", "container-title", "issued"],
    },
    "article-newspaper": {
      required: ["title", "container-title", "issued"],
    },
    book: {
      required: ["title", "issued"],
    },
    broadcast: {
      required: ["title", "container-title", "issued"],
    },
    document: {
      required: ["title", "type"],
    },
    interview: {
      required: ["title", "interviewee", "interviewer", "issued"],
    },
    map: {
      required: ["title"],
    },
    post: {
      required: ["title", "container-title", "issued"],
    },
    report: {
      required: ["title", "publisher", "issued"],
    },
    review: {
      required: ["title", "item"],
    },
    thesis: {
      required: ["title", "publisher", "issued"],
    },
    webpage: {
      required: ["title"],
    },
  },
};

export default inputConfig;

/* 
[
  "article",
  "article-journal",
  "article-magazine",
  "article-newspaper",
  "book",
  "broadcast",
  "document",
  "interview",
  "map",
  "post",
  "report",
  "review",
  "thesis",
  "webpage",
];
*/
